import { REPORT_REGIONS } from "../data/reportsData"
import { toISODate } from "./parseReportFile"

// Reports that share the same date (extracted from their filename)
// belong to the same weekly batch, so grouping is just a bucket-by-date.
// Within a week, reports are ordered to match REPORT_REGIONS — Global
// first, then the regions in the order they're declared there.
const REGION_ORDER = REPORT_REGIONS.map((r) => r.key)

const sortWithinWeek = (reports) =>
  [...reports].sort(
    (a, b) => REGION_ORDER.indexOf(a.key) - REGION_ORDER.indexOf(b.key)
  )

/**
 * @param {import("./parseReportFile").Report[]} reports
 * @returns {{ id: string, weekOf: string, isCurrent: boolean, isNew: boolean, reports: object[] }[]}
 *   Sorted newest week first. The newest week is flagged `isCurrent`.
 *   A week is flagged `isNew` only when its date is literally today.
 */
export const groupReportsIntoWeeks = (reports) => {
  const byWeek = new Map()

  reports.forEach((report) => {
    if (!byWeek.has(report.weekOf)) byWeek.set(report.weekOf, [])
    byWeek.get(report.weekOf).push(report)
  })

  const todayIso = toISODate(new Date())

  return Array.from(byWeek.entries())
    .sort(([weekOfA], [weekOfB]) => (weekOfA < weekOfB ? 1 : -1)) // newest first
    .map(([weekOf, weekReports], index) => ({
      id: `week-${weekOf}`,
      weekOf,
      isCurrent: index === 0,
      isNew: weekOf === todayIso,
      reports: sortWithinWeek(weekReports),
    }))
}
